import { m } from 'framer-motion';
import { Col } from 'react-bootstrap';
import { fadeIn } from '../../Functions/GlobalAnimations';
import Loading from '../../Components/Loading';
import InteractiveBanners03 from '../../Components/InteractiveBanners/InteractiveBanners03';

const Events = () => {
	// Dummy Events Data
	const eventsData = [
		{
			title: "Agricultural Technology Summit 2024",
			description: "Join us for a comprehensive summit on latest agricultural technologies and innovations",
			image: "https://assets.bucketlistly.blog/sites/5adf778b6eabcc00190b75b1/content_entry5adf77af6eabcc00190b75b6/6075185986d092000b192d0a/files/best-free-travel-images-main-image-hd-op.webp",
			attachment: "/files/agri-tech-summit-details.pdf",
			url: "/events/agricultural-technology-summit-2024",
			titleLink: "/events/agricultural-technology-summit-2024"
		},
		{
			title: "Farmer's Training Workshop",
			description: "Hands-on training program for modern farming techniques and best practices",
			image: "/images/events/farmers-workshop.jpg",
			attachment: "/files/farmers-workshop-schedule.pdf",
			url: "/events/farmers-training-workshop",
			titleLink: "/events/farmers-training-workshop"
		},
		{
			title: "Organic Farming Expo 2024",
			description: "Explore the latest trends in organic farming and sustainable agriculture",
			image: "/images/events/organic-farming-expo.jpg",
			attachment: "/files/organic-farming-expo-brochure.pdf",
			url: "/events/organic-farming-expo-2024",
			titleLink: "/events/organic-farming-expo-2024"
		},
		{
			title: "KERA Startup Pitch Day",
			description: "Agri-tech startups showcase their innovations to investors and industry experts",
			image: "/images/events/startup-pitch-day.jpg",
			attachment: "/files/startup-pitch-day-guidelines.pdf",
			url: "/events/kera-startup-pitch-day",
			titleLink: "/events/kera-startup-pitch-day"
		},
		{
			title: "Food Processing Industry Meet",
			description: "Networking event for food processing MSMEs and industry stakeholders",
			image: "/images/events/food-processing-meet.jpg",
			attachment: "/files/food-processing-meet-agenda.pdf",
			url: "/events/food-processing-industry-meet",
			titleLink: "/events/food-processing-industry-meet"
		},
		{
			title: "Export Readiness Training Program",
			description: "Learn about export documentation, compliance, and international market access",
			image: "/images/events/export-training.jpg",
			attachment: "/files/export-training-details.pdf",
			url: "/events/export-readiness-training",
			titleLink: "/events/export-readiness-training"
		}
	];

	// if ('') return <Loading />;

	return (
		<>
			<m.div className="container mt-[200px] mb-[50px]">
				<Col xl={8} lg={10} className="text-center w-fit">
					<h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] -tracking-[1px]">
						Events
					</h3>
					<m.div
						className="border-b border-1 w-[40%] border-[#146084]"
						initial={{ scaleX: 0 }}
						animate={{ scaleX: 1 }}
						transition={{ duration: 0.5, delay: 0.2 }}
					/>
				</Col>

				<section>
					<div className="mt-[70px]">
						<InteractiveBanners03
							link={true}
							grid="row-cols-1 row-cols-md-2 row-cols-lg-3 gap-y-10"
							overlay={['#0000004a', '#0000004a']}
							data={eventsData}
							animation={fadeIn}
						/>
					</div>
				</section>
			</m.div>
		</>
	);
};

export default Events;